import { StyledFab } from "./styles";
import { FabProps } from "./types";

export const Fab: React.FC<FabProps> = ({ type = "button", ...props }) => (
  <StyledFab type={type} {...props} />
);
